var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuItemBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 24,
  viewBox: "0 0 60 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b_1825_1152)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60 24V11.1041L41.0208 0L0 24L60 24Z",
  fill: "white",
  fillOpacity: 0.05
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b_1825_1152",
  x: -80,
  y: -80,
  width: 220,
  height: 184,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 40
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1825_1152"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1825_1152",
  result: "shape"
})))));
export { SvgMenuItemBackground as ReactComponent };
export default __webpack_public_path__ + "assets/6e140cdd.svg";